import { render, staticRenderFns } from "./AgencyBrokersAccounting.vue?vue&type=template&id=5528f3e8&scoped=true&"
import script from "./AgencyBrokersAccounting.vue?vue&type=script&lang=js&"
export * from "./AgencyBrokersAccounting.vue?vue&type=script&lang=js&"
import style0 from "./AgencyBrokersAccounting.vue?vue&type=style&index=0&id=5528f3e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5528f3e8",
  null
  
)

export default component.exports